export enum YearsOfExp {
	LESS_THAN_ONE = 'Less than 1 year',
	ONE_TO_THREE = '1-3 years',
	THREE_TO_FIVE = '3-5 years',
	FIVE_TO_SEVEN = '5-7 years',
	MORE_THAN_SEVEN = 'More than 7 years'
}
